import permission from "@/middlewares/permission";


function loadView( view ) {
    return () => import(`@/views/admin/nrk/${ view }.vue`);
}


const Index = loadView( 'Index' );
const NRKView = loadView( 'View' );

const nrkRoutes = [

    {
        path: 'nrk',
        name: 'api.nrk.resource.getList',
        component: Index,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'nrk/:id/:type?',
        name: 'api.nrk.resource.get',
        component: NRKView,
        meta: {
            middleware: permission
        }
    }
];
export default nrkRoutes;
